export function getFontWeight(
  highlight: boolean | undefined,
  bold: boolean | undefined,
): 'normal' | 'medium' | 'bold' {
  if (highlight) return 'medium';
  if (bold) return 'bold';
  return 'normal';
}
